import React, { Component, useState, useEffect, useMemo } from 'react';
import { Badge, Collapse, Modal,  ModalHeader,  ModalBody,  ModalFooter,  ButtonGroup,  Card,  CardBody,  CardHeader,  CardFooter, Col,  Row,  Button,  Input,  FormGroup,  Label,  
         FormFeedback,  Form} from 'reactstrap';
import { confirmAlert } from 'react-confirm-alert'; 
import 'react-confirm-alert/src/react-confirm-alert.css';
import {Typeahead} from 'react-bootstrap-typeahead'; 
import 'react-bootstrap-typeahead/css/Typeahead.css';

import * as XLSX from 'xlsx';

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import DataTable from 'react-data-table-component';

import "react-datepicker/dist/react-datepicker.css";
import { AppSwitch } from '@coreui/react'

import { getAction, postAction, upAction, putAction, deleteAction, postActionExterno, RutUtils } from '../../utils/ApiHandler';
import { customStyles_imagen, TextField, ClearButton } from '../../utils/customStyle';  
import btn_buscar from '../../assets/img/buscar.png'

import Loader from "react-spinners/MoonLoader";
import { css } from "@emotion/core";
const override = css`
  display: block;
  position: fixed;
  margin: 0 auto;
  z-index: 9999;
  left: 50%;
  top: 25%;
  border-color: red;
  `;

const Users = () => {
  //Hooks de estado para manejo de cambios (ex setState)
    const [modalTitle, setModalTitle] = useState('');
    const [modal, setModal] = useState(false);
    const [data,                setData]              = useState([]);
    const [userId,              setUserId]            = useState('')
    const [profiles,            setProfiles]          = useState([])
    const [nombreInput,         setNombreInput]       = useState('');
    const [usernameInput,       setUsernameInput]     = useState('');
    const [prevUsernameInput,   setPrevUsernameInput] = useState('');
    const [rutInput,            setRutInput]          = useState(''); 
    const [mailInput,           setMailInput]         = useState('');
    const [isActive,            setIsActive]          = useState(false);
    const [isUser,              setIsUser]            = useState(true);
    const [selectedProfile,     setSelectedProfile]   = useState([]);
    const [nombreInputError,    setNombreInputError]  = useState({valid: true, message: ''});
    const [usernameInputError,  setUsernameInputError] = useState({valid: true, message: ''});
    const [rutInputError,       setRutInputError]     = useState({valid: true, message: ''});
    const [mailInputError,      setMailInputError]    = useState({valid: true, message: ''});
    const [selectedProfileError,setSelectedProfileError] = useState({valid: true, message: ''});

    const [passwordInput,       setPasswordInput]     = useState('');
    const [repasswordInput,     setRePasswordInput]   = useState('');
    const [passwordInputError,  setPasswordInputError] = useState({valid: true, message: ''});
    const [rePasswordInputError,setRePasswordInputError] = useState({valid: true, message: ''});
    const [changePassword,      setChangePassword]    = useState(false)

    const [getConfigApp,        setConfigApp]         = useState('');

    const [getClaves,           setClaves]      = useState('');
    const [getFotoDefault,      setFotoDefault] = useState(''); 
    const [getFoto,             setFoto]        = useState(''); 

    const [files,               setFiles]       = useState([]);
    const [getLogoEmpresa,      setLogoEmpresa] = useState('');

    const empresa_id = localStorage.getItem('userData') ? JSON.parse(localStorage.getItem('userData')).empresa_id : '';
    const numberFormat2 = new Intl.NumberFormat('en-AR', {maximumFractionDigits: 0, minimumFractionDigits: 0});
    const [getGifLoader,  setGifLoader] = useState(false);


  const toggle = () => {
    setModalTitle('Agregar usuario')
    setUserId('')
    setUsernameInput('')
    setNombreInput('')
    setRutInput('')
    setMailInput('')
    setSelectedProfile([])
    setPasswordInput('')
    setFoto(getFotoDefault)

    setRePasswordInput('')
    hideErrors();
    setIsActive(false)
    setIsUser(true)
    setModal(!modal);
  }

  useEffect(() => {
    getUserList();
    getProfileList();
    getAppConfig();
    getConfigLogoEmpresa();
    getConfig();
  }, []);

  const getUserList = async () => {
    try{
      setGifLoader(true)
      const res = await getAction('/api/users/' + empresa_id)
      if (!res.ok) {
          throw Error(res.statusText);
      }
      res.json()
      .then((resp => {
        setGifLoader(false)
        setData(resp.data)
      })
      )
    }
    catch (err) {
      setGifLoader(false)
      toast.error(<span><i className="fa fa-minus-circle"></i> Error al intentar obtener la lista de comunas!</span>, {position: toast.POSITION.TOP_RIGHT})
    }
  }

  const getProfileList = async () => {
    try {
      setGifLoader(true)
      const res = await getAction('/api/profiles')
      if (!res.ok) {
        throw Error(res.statusText);
      }
      res.json()
      .then((resp => {
        setProfiles(resp.data)
        setGifLoader(false)
      })
      )
    }
    catch (err) {
      setGifLoader(false)
      toast.error(<span><i className="fa fa-minus-circle"></i> Error al intentar obtener la lista de Perfiles!</span>, {position: toast.POSITION.TOP_RIGHT})
    }
  }

  const getAppConfig = async () => {
    const name = 'foto_default'
    try {
        const res = await getAction('/api/appConfigNombre_json/'+ name)
        if (!res.ok) {
          throw Error(res.statusText);
        }
        res.json()
        .then((resp => {
            setFotoDefault(resp.data[0].config.url_foto)
          })
        )
      }
      catch (err) {
        toast.error(<span><i className="fa fa-minus-circle"></i> Error al intentar obtener Foto Defecto!</span>, {position: toast.POSITION.TOP_RIGHT})
      }
  }
  const getConfig = async () => {
      const name = 'envioMailUser'
      try {
          const res = await getAction('/api/appConfigNombre_json/'+ name)
          if (!res.ok) {
            throw Error(res.statusText);
          }
          res.json()
          .then((resp => {
              if (resp.data.length === 0) {
                  toast.error(<span><i className="fa fa-minus-circle"></i> No existe URL para Pago de Alcantarillado.</span>, {position: toast.POSITION.TOP_RIGHT})
                  return
              }
              if (resp.data[0].config.url === "") {
                  toast.warning(<span><i className="fa fa-minus-circle"></i> No existe URL para Pago de Alcantarillado</span>, {position: toast.POSITION.TOP_RIGHT})
                  return
              }
              setConfigApp(resp.data[0].config);
            })
          )
      }
      catch (err) {
        toast.error(<span><i className="fa fa-minus-circle"></i> Error al intentar obtener Pagos de Alcantarillado!</span>, {position: toast.POSITION.TOP_RIGHT})
      }
  }  
  const getConfigLogoEmpresa = async () => {
      const name = 'logoEmpresa'
      try {
          const res = await getAction('/api/appConfigNombre_json/'+ name)
          if (!res.ok) {
            throw Error(res.statusText);
          }
          res.json()
          .then((resp => {
              if (resp.data.length === 0) {
                  toast.error(<span><i className="fa fa-minus-circle"></i> No existe URL Logo de Empresa.</span>, {position: toast.POSITION.TOP_RIGHT})
                  return
              }
              if (resp.data[0].config.url === "") {
                  toast.warning(<span><i className="fa fa-minus-circle"></i> No existe URL Logo de Empresa</span>, {position: toast.POSITION.TOP_RIGHT})
                  return
              }
              setLogoEmpresa(resp.data[0].config);
            })
          )
      }
      catch (err) {
        toast.error(<span><i className="fa fa-minus-circle"></i> Error al intentar obtener Pagos de Alcantarillado!</span>, {position: toast.POSITION.TOP_RIGHT})
      }
  }  

  const createUser = async (user) => {
    try {
      setGifLoader(true)
      const res = await postAction('/api/users', user);
      if (!res.ok) {
        if(res.status === 422)
          res.json().then(err_resp => showErrors (err_resp.errors))
        throw Error(res.statusText);
      }
      res.json()
      .then((resp => {
        setData(data => [...data, resp.data])
        EnviarCorreo(1, user);
        toggle();
        setGifLoader(false)
        toast.success(<span><i className="fa fa-successs"></i> Datos guardados con exito!</span>, {position: toast.POSITION.TOP_RIGHT})
      })
      )
    }
    catch (err) {
      toast.error(<span><i className="fa fa-minus-circle"></i> Error al guardar datos!</span>, {position: toast.POSITION.TOP_RIGHT})
    }
  }

  const updateUser = async (user) => {
    try {
      setGifLoader(true)
      const res = await putAction('/api/users/' + user.id, user)
      if (!res.ok) {
        if(res.status === 422)
          res.json().then(err_resp => showErrors (err_resp.errors))
        throw Error(res.statusText);
      }
      res.json()
      .then((resp => {
        let newArr = [...data]; // copying the old datas array      
        let index = data.findIndex((o) => { return o.id === user.id });
        newArr[index] = resp.data
        setData(newArr);
        EnviarCorreo(2, user);
        toggle();
        setGifLoader(false)
        toast.success(<span><i className="fa fa-successs"></i> Datos actualizados con exito!</span>, {position: toast.POSITION.TOP_RIGHT})
      })
      )
    }
    catch (err) {
      setGifLoader(false)
      toast.error(<span><i className="fa fa-minus-circle"></i> Error al guardar datos!</span>, {position: toast.POSITION.TOP_RIGHT})
    }
  }


  //ZONA de filtro
    const [filterText, setFilterText] = useState('');
    const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
    const FilterComponent = ({ filterText, onFilter, onClear, onFocus, onChangeText }) => (
      <>
        <TextField id="search" type="text" placeholder="Filtro" value={filterText} onChange={onFilter} autoFocus={true}  />
        <ClearButton onClick={onClear}>X</ClearButton>
      </>
    );
    const subHeaderComponentMemo = React.useMemo(() => {
      const handleClear = () => {
        if (filterText) {
          setResetPaginationToggle(!resetPaginationToggle);
          setFilterText('');
        }
      };
      return <FilterComponent  onFilter={e => setFilterText(e.target.value.toUpperCase())} onFocus={e => setFilterText(e.target.onFocus)}  onClear={handleClear} filterText={filterText.toUpperCase()}   />;
    }, [filterText, resetPaginationToggle]);
   
    const filteredItems = data.filter(item => ((item.name.toUpperCase().includes(filterText))     || 
                                               (item.username.toUpperCase().includes(filterText))                                               )
                                      );
  //Fin Filtro


  const postUploadFile = async (e) => {
    try {
      setGifLoader(true)
      const _form = new FormData()
      _form.append('files', files[0], files[0].name)
      const res = await upAction('/api/open/userfileUpload/' + userId, _form)
      if (!res.ok) {
        if(res.status === 422)
          res.json().then(err_resp => showErrors (err_resp.errors))
        throw Error(res.statusText);
      }
      res.json()
      .then((resp => {
        setGifLoader(false)
        setFoto(resp.data.url_foto)
        let newArr = [...data];
        let index = data.findIndex((o) => { return o.id === userId });
        newArr[index] = resp.data
        setData(newArr);
        toast.success(<span><i className="fa fa-successs"></i> Subida de Archivo con éxito.</span>, {position: toast.POSITION.TOP_RIGHT})
      }))
    }
    catch (err) {
      setGifLoader(false)
      toast.error(<span><i className="fa fa-minus-circle"></i> Error al guardar datos!</span>, {position: toast.POSITION.TOP_RIGHT})
    }
  }

  const EnviarCorreo = async (tipo, user) => {
      var envioMail = [];
      var _tipo   = tipo === 1 ? 'Creación de Usuario ' : 'Actualización de Usuario ';
      var passw   = user.password ? " y su contraseña es: " +  user.password : '';
      var _perfil = user.profiles[0] ? "Perfil: " + user.profiles[0].name  : '';
      let asunto  = _tipo +  user.name;
      let mailDestinatario = user.mail;
      // let link = getConfigApp.url_boleta + doc.empresa_id + "/"+ doc.id;
      let cuerpo = 
              "<!DOCTYPE html> " +
              "<html> " +
              "<head> " +
              "</head> " +
              "<style> " +
              " " +
              "</style> " +
              "<body style='margin-left: 35px;'> " +
              "  <p> " +
              "    <img src='" + getLogoEmpresa.url + "'  width='80px' height= '40px'/><br> " +
              "  </p> " +
              "  <Row> " +
              "    <p> Estimado(a) : <strong><h2> " + user.name + "</h2></strong></p> " +
              "  </Row> " +
              "  <p>Su nombre de usuario es: <strong>" + user.username + passw  + "</strong></p> " +
              "  <br><br>  " +
              "  <p>" + _perfil  + "</p> " +
              "  <br><br> " +
              "  <p>Atentamente, </p> " +
              // "  <p><strong>" + doc.razon.toString() + "</strong></p> " +
              "  <br><br> " +
              "  <p style='border: 1px solid #8d8a8a; background-color: #f1f1f1; padding: 15px; border-radius: 5px; width: 65%;''> " +
              "    Nota: Este e-mail es generado de manera automatica, por favor no respondas a este mensaje.</p> " +
              "  </p>  " +
              "</body>  " +
              "</html>  "

      
      let mail = {
          "asuntoMail"      :  asunto,
          "cuerpoMail"      : cuerpo,
          "archivo"         :"",
          "nombreArchivo"   : "",
          "mailOrigen"      : getConfigApp.mailorigen,
          "mailDestinatario": mailDestinatario
      }
      envioMail.push(mail);
      const res = await postActionExterno(getConfigApp.api_envio, { "listaMail": envioMail})
      if (!res.ok) {
          throw Error(res.statusText);
      }
      res.json()
      .then((resp => {
          toast.success('Se notificó por Correo ...')
          // (() => setInterval(async () => {
          //   await refreshProcess();
          // }, 5000))();
        })
      )
  }

  const deleteUser = async (userId) => {
    try {
      const res = await deleteAction('/api/users/' + userId)
      if (!res.ok) {
        throw Error(res.statusText);
      }
      res.json()
      .then((resp => {
        console.log(resp.data)
        setData(data.filter(item => item.id !== userId))
        toast.success(<span><i className="fa fa-successs"></i> Registro eliminado con exito!</span>, {position: toast.POSITION.TOP_RIGHT})
      })
      )
    }
    catch (err) {
      toast.error(<span><i className="fa fa-minus-circle"></i> Error al eliminar datos!</span>, {position: toast.POSITION.TOP_RIGHT})
    }
  }

  const editUserAction = (e, row) => {
    toggle()
    setUserId(row.id)
    setModalTitle('Editar usuario')
    setUsernameInput(row.username)
    setNombreInput(row.name)
    setPrevUsernameInput(row.username)
    setRutInput(row.sgi_rut)
    setMailInput(row.mail)
    setIsActive(row.is_active)
    setIsUser(row.is_user)
    setSelectedProfile(row.profiles)
    row.url_foto ? setFoto(row.url_foto) : setFoto(getFotoDefault)
  }

  const showErrors = (errors) => {
    errors.forEach(err => {
      switch(err.param) {
        case 'sgi_rut':
          setRutInputError({valid:false, message: err.msg })
          break
        case 'name':
          setNombreInputError({valid:false, message: err.msg })
          break
        case 'username':
          setUsernameInputError({valid:false, message: err.msg })
          break
        case 'mail':
          setMailInputError({valid:false, message: err.msg })
          break
        default:
          break;
      }
    })
  }

  const hideErrors = () => {
    setRutInputError({valid:true, message: '' })
    setNombreInputError({valid:true, message: '' })
    setUsernameInputError({valid:true, message: '' })
    setMailInputError({valid:true, message: '' })
    setSelectedProfileError({valid:true, message: '' })
  }


  const saveTownChangesAction = (e) => {    
    e.preventDefault();
    hideErrors()
    var rut = rutInput.replace('.', '');
        rut = rut.replace('.', '');
    if(rutInput.length === 0){
      setRutInputError({valid:false, message: 'Rut no puede estar vacio' })
      return
    } 
    if(!RutUtils.validaRut(rut)){
      setRutInputError({valid:false, message: 'El Rut ingresaddo no es valido' })
      return
    }
    
    if(nombreInput.length === 0){
      setNombreInputError({valid:false, message: 'Nombre no puede estar vacio' })
      return
    }

    if(usernameInput.length === 0){
      setUsernameInputError({valid:false, message: 'Nombre de usuario no puede estar vacio' })
      return
    }

    if(mailInput.length === 0){
      setMailInputError({valid:false, message: 'Email no puede estar vacio' })
      return
    }

    if(selectedProfile.length === 0){
      setSelectedProfileError({valid:false, message: 'Debe haber al menos un perfil seleccionado' })
      return
    }
    if (passwordInput !== repasswordInput){
        toast.error(<span><i className="fa fa-minus-circle"></i> Las claves no son idénticas.</span>, {position: toast.POSITION.TOP_RIGHT})
        return
    }

    var editedUserData = {
      empresa_id : empresa_id,
      name       : nombreInput,
      username   : usernameInput,
      mail       : mailInput,
      is_active  : isActive,
      is_user    : isUser,
      profiles   : selectedProfile,
      password   : passwordInput,
      repassword : passwordInput ? repasswordInput : ""
    }
    if(userId === ''){
      editedUserData.sgi_rut = rut
      createUser(editedUserData)
    }else{
      editedUserData.id = userId
      updateUser(editedUserData)
    }
  }

  const deleteUserAction= (e, row) => {
    confirmAlert({
      title: 'Eliminar Usuario',
      message: row.name + '?', 
      buttons: [
        {
          label: 'Si',
          onClick: () => {
            deleteUser(row.id)
            console.log(row.id)
          }
        },
        {
          label: 'No'
        }
      ]
    });
  }

  const checkUsername = async (e)  => {
    if(prevUsernameInput !== e.target.value)
    {
    try {
      const res = await getAction('/api/users/checkuser/' + e.target.value)
       if (!res.ok) {
         if(res.status === 422)
           res.json().then(err_resp => showErrors (err_resp.errors))
         throw Error(res.statusText);
       }
       res.json()
       .then((resp => {
            setUsernameInputError({valid:!resp.data, message: (!resp.data) ? 'Usuario disponible' : 'Usuario ya esta en uso!' })
       })
       )
     }
     catch (err) {
        toast.error(<span><i className="fa fa-minus-circle"></i> Error al comprobar el usuario!</span>, {position: toast.POSITION.TOP_RIGHT})
     }
    }
      return false;
  }
 
  const  configuraRut = (rut) => {  
      setRutInput(formatRut(rut))
  }
  const  formatRut = (rut) => {  
    var newrut = ''
    if (rut === '' || rut === '0-') {
    } else if (rut.length === 1) {
      newrut =  rut
    } else {
        var valor  = rut.replace('-','');
        var cuerpo = valor.slice(0,-1);
        cuerpo  = cuerpo.replace('.','');
        cuerpo  = cuerpo.replace('.','');
        cuerpo ? cuerpo = parseInt(cuerpo) : valor = 0;
        cuerpo = numberFormat2.format(cuerpo).replace(/,/g, '.')
        var dv = rut.slice(-1).toUpperCase();
        newrut = cuerpo + '-'+ dv
    }
    return newrut
  }

  const generarClave = async (e)  => {
    var caracteres = "abcdefghijkmnpqrtuvwxyz012346789#$%&";
    var contraseña = "";
    var i = 0
    for (i=0; i<6; i++) contraseña +=caracteres.charAt(Math.floor(Math.random()*caracteres.length)); 
    setPasswordInput(contraseña)
    setRePasswordInput(contraseña)
  }
  
  const columns = [
    {
      name: 'Imagen',
      selector: 'url_foto',
      sortable: true,
      width: "100px",
      cell: row => row.url_foto ? <img src={row.url_foto} className="fotomin" width="50px" height= "50px"/> : <img src={getFotoDefault} className="fotomin" width="50px" height= "50px"/>,
    },
    {
      name: 'Rut',
      selector: 'sgi_rut',
      sortable: true,
      width: "120px"
    },
    {
      name: 'Nombre de Usuario',
      sortable: true,
      selector: 'name',
      width: "350px"
    },
    {
      name: 'UserName',
      selector: 'username',
      sortable: true,
      width: "200px"
    },
    {
      name: 'Email',
      selector: 'mail',
      sortable: true,
      width: "250px"
    },
    {
      name: 'Activo?',
      selector: 'is_active',
      cell: row => row.is_active ? <h5><Badge color="success" style={{marginTop: "5px"}}> Si </Badge></h5> : <></>,
      center: 'true', 
      sortable: true,
      width: "80px"
    },
    {
      name: 'Solo Usuario?',
      selector: 'is_user',
      cell: row => row.is_user ? <h5><Badge color="success" style={{marginTop: "5px"}}> Si </Badge></h5> : <></>,
      center: 'true', 
      sortable: true,
      width: "200px"
    },
    {
      cell: row => <></>,
      ignoreRowClick: true,
      allowOverflow: true,
    },
    {
      cell: row => <ButtonGroup>
                      <Button title={(row.id ===JSON.parse(localStorage.getItem('userData')).id) ? 'Para editar su usuario debe ir a las opciones de arriba' : 'Editar'} disabled={row.id ===JSON.parse(localStorage.getItem('userData')).id} onClick={(e) => editUserAction(e, row)} style={{marginRight: "5px", borderRadius: "5px"}}><i className="icon-pencil fa-boton"></i></Button>
                      <Button title={(row.id ===JSON.parse(localStorage.getItem('userData')).id) ? 'No puede borrar su propio usuario' : 'Borrar'} disabled={row.id ===JSON.parse(localStorage.getItem('userData')).id} onClick={(e) => deleteUserAction(e, row)} style={{marginRight: "5px", borderRadius: "5px"}}><i className="icon-trash fa-boton"></i></Button>
                  </ButtonGroup>,
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
  ];

                // <input type="file" accept="text/plain"  onChange={(e) => setFiles(e.target.files)} style={{marginLeft: "15px"}}/>
                // <input type="file" accept="image/png, image/jpeg"  onChange={(e) => setFiles(e.target.files)} style={{marginLeft: "15px"}}/>
                // <input type="file"accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" onChange={(e) => setFiles(e.target.files)} style={{marginLeft: "15px"}}/>


  return (
    <div className="animated fadeIn">
      <ToastContainer />
      <Row>
        <Col xs="12" lg="10">
          <div className="sweet-loading">
            <Loader
              css={override}
              size={80}
              color={"#4A90E2"}
              loading={getGifLoader}
            />
          </div>
        </Col>
      </Row>
      <Row>
        <Col xs="12" lg="12">
          <Card>
            <CardHeader>
              <i className="fa fa-align-justify"></i> Usuarios
              <div className="card-header-actions">
                <Button id="_agregar" color="primary" onClick={toggle} className="btn-setting"><i className="fa fa-plus"></i> Agregar</Button>
              </div>
            </CardHeader>
            <CardBody>
              <DataTable
                  columns={columns}
                  data={filteredItems}
                  nopagination
                  noHeader
                  customStyles={customStyles_imagen}
                  highlightOnHover
                  defaultSortField="nombre"
                  persistTableHead
                  pagination
                  paginationPerPage={5}
                  paginationComponentOptions={{
                            rowsPerPageText: 'Filas por página:',
                            rangeSeparatorText: 'de',
                  }}
                  paginationRowsPerPageOptions={[5, 10, 15, 20]}
                  subHeader
                  subHeaderComponent={subHeaderComponentMemo}
                  persistTableHead
              />
            </CardBody>
          </Card>
        </Col>
      </Row>
      <Modal isOpen={modal} toggle={toggle} className="modal-dialog  modal-lg modal-dialog-centered">
          <CardHeader className="cardHeader">
              <i className="icon-note"></i> {modalTitle}
          </CardHeader>
          <CardBody>
            <Row>
              <Col md="8">
                <Row style={{margin: "0px"}}>
                  <Label md="3">Rut</Label>
                  <Col md="4" style={{paddingLeft: "0px"}}>
                    <Input type="text" placeholder="Rut" invalid={!rutInputError.valid} id="rut" value={rutInput} onChange={(e) => { setRutInput(e.target.value); configuraRut(e.target.value.toUpperCase())}}></Input>
                    <FormFeedback>{rutInputError.message}</FormFeedback>
                  </Col>
                </Row>  
                <Row style={{margin: "10px 0px 0px 0px"}}>
                  <Label md="3">Nombre</Label>
                  <Col md="8" style={{paddingLeft: "0px"}}>
                      <Input type="text" placeholder="Nombre" invalid={!nombreInputError.valid} id="nombre" value={nombreInput} onChange={(e) => setNombreInput(e.target.value.toUpperCase())}></Input>
                      <FormFeedback>{nombreInputError.message}</FormFeedback>
                  </Col>
                </Row>
                <Row style={{margin: "10px 0px 0px 0px"}}>
                  <Label md="3">Mail</Label>
                  <Col md="8" style={{paddingLeft: "0px"}}>
                    <Input type="text" placeholder="Mail" invalid={!mailInputError.valid} id="mail" value={mailInput} onChange={(e) => setMailInput(e.target.value)}></Input>
                    <FormFeedback>{mailInputError.message}</FormFeedback>
                  </Col>
                </Row>
                <Row style={{margin: "10px 0px 0px 0px"}}>
                  <Label md="3">UserName</Label>
                  <Col md="8" style={{paddingLeft: "0px"}}>
                      <Input type="text" onBlur={e => checkUsername(e)} placeholder="Nombre usuario" invalid={!usernameInputError.valid} id="username" value={usernameInput} onChange={(e) => setUsernameInput(e.target.value)}></Input>
                      <FormFeedback>{usernameInputError.message}</FormFeedback>
                  </Col>
                </Row>
                <Row style={{margin: "10px 0px 0px 0px"}}>
                    <Label md="3">Perfiles</Label>
                    <Col md="8" style={{paddingLeft: "0px"}}>
                      <Typeahead
                        id="region_select"
                        labelKey="name"
                        multiple={true}
                        options={profiles}
                        selected={selectedProfile}
                        onChange={(selected) => setSelectedProfile(selected)}
                        placeholder="Selecciona un Perfil..."
                      />
                      <small className="text-danger">{selectedProfileError.message}</small>
                    </Col>
                </Row>
                <Row style={{margin: "0px"}}>
                    <Label md="3">Usuario Activo</Label>
                    <Col md="2" style={{paddingLeft: "0px"}}>
                          <AppSwitch className={'mx-1'} variant={'3d'} color={'primary'} checked={isActive} onChange={(e) => { setIsActive(e.target.checked)}}/>
                          <Label className="switch switch-text switch-pill switch-primary">
                              <input type="checkbox" className="switch-input" defaultChecked />
                              <span className="switch-label" data-on="On" data-off="Off"></span>
                              <span className="switch-handle"></span>
                          </Label>
                    </Col>
                </Row>  
                <Row style={{margin: "0px"}}>
                    <Label md="3">Es solo Usuario</Label>
                    <Col md="2" style={{paddingLeft: "0px"}}>
                          <AppSwitch className={'mx-1'} variant={'3d'} color={'primary'} checked={isUser} onChange={(e) => { setIsUser(e.target.checked)}}/>
                          <Label className="switch switch-text switch-pill switch-primary">
                              <input type="checkbox" className="switch-input" defaultChecked />
                              <span className="switch-label" data-on="On" data-off="Off"></span>
                              <span className="switch-handle"></span>
                          </Label>
                    </Col>
                </Row>  
              </Col>
              <Col md="4">
                    <img src={getFoto} className="foto" width="300px" height= "250px" alt="ImagenCliente" />
              </Col>
            </Row>
            <Row style={{margin: "35px 0px 0px 0px"}}>
                <Label md="2"> Cambiar contraseña</Label>
                <Col md="1" style={{paddingLeft: "0px"}}>
                    <AppSwitch id="change_password" className={'mx-1'} variant={'3d'} color={'primary'} checked={changePassword} onChange={(e) => { setChangePassword(e.target.checked)}}/>
                </Col>
                <Collapse isOpen={changePassword}>
                  <Row>
                    <Label style={{margin: "5px 0px 0px 15px"}}>Contraseña</Label>
                    <Col md="2">
                      <Input type="text" placeholder="Contraseña" invalid={!passwordInputError.valid} id="password" value={passwordInput} onChange={(e) => setPasswordInput(e.target.value)}></Input>
                      <FormFeedback>{passwordInputError.message}</FormFeedback>
                    </Col>
                    <Label style={{margin: "5px 10px 0px 0px"}}>Repetir</Label>
                    <Col md="2" style={{paddingLeft: "0px"}}>
                      <Input type="text" placeholder="ccontraseña" invalid={!rePasswordInputError.valid} id="repassword" value={repasswordInput} onChange={(e) => setRePasswordInput(e.target.value)} ></Input>
                      <FormFeedback>{rePasswordInputError.message}</FormFeedback>
                    </Col> 
                    <Col style={{marginLeft: "35px"}}>
                      <Button color="primary" onClick={generarClave} >Generar Clave</Button>{' '}
                    </Col>
                  </Row>
                </Collapse>
            </Row>

            <Row style={{margin: "35px 0px 0px 0px", borderStyle:"solid", borderColor:"#9da5ab", borderWidth:"1px"}}>
              <strong md="2" style={{margin: "17px"}}>Imagen del Usuario</strong>
              <Col md="6" style={{marginTop: "15px"}}>
                <input type="file"  onChange={(e) => setFiles(e.target.files)} style={{marginLeft: "15px"}} accept="image/png, image/jpeg" />
              </Col>
              <Col md="2" style={{marginTop: "12px", color:"white"}}>
                <Button  color="info" onClick={ postUploadFile }>Subir Archivo</Button>
              </Col>
            </Row>
          </CardBody>
          
          <CardFooter >
              <Button color="success" onClick={toggle} className="btn btn-setting" style={{float: "right", marginRight: "20px"}}><i className="icon-logout"></i> Volver</Button>
              <Button color="primary" onClick={saveTownChangesAction} style={{float: "right", marginRight: "20px"}}>Guardar Cambios</Button>{' '}
          </CardFooter>
      </Modal>
    </div>
  );
}

export default Users;
